import React, { useEffect, useState } from "react";
import ApiService from "../../../services/api";
import { toast } from "react-toastify";
import "../css/coupon_reminder.css";
import Coupon from '../../../media/coupon.png';

function CouponReminder() {

  const [showOverlay, setShowOverlay] = useState(false);
  const [orgCode, setOrgCode] = useState("");
  const [joinLoading, setJoinLoading] = useState(false);
  const [showMini, setShowMini] = useState(false);
  const [closing, setClosing] = useState(false);


  useEffect(() => {

    const checkCourses = async () => {

      try {

        const courses = await ApiService.getMyCourses();

        console.log("CORSI UTENTE:", courses);


        if (!courses || courses.length === 0) {
          setShowOverlay(true);
        }


      } catch (err) {
        console.error("Errore controllo corsi:", err);
      }

    };


    checkCourses();

  }, []);

  const handleJoinOrganization = async () => {

    if (!orgCode) return;

    setJoinLoading(true);

    try {

        await ApiService.joinOrganization({
        code: orgCode,
        });


        toast.success("Codice registrato con successo");

        setOrgCode("");

        setShowOverlay(false);


    } catch (err) {

        console.error(err);

        toast.error(
        err?.response?.data?.error ||
        "Errore durante il join"
        );

    } finally {

        setJoinLoading(false);

    }

    };

  const closeOverlay = () => {

    setClosing(true);
    setShowOverlay(false);
    setClosing(false);

    };



  if (!showOverlay) {
    return null;
  }



  return (
    <div
      className={`coupon-overlay ${closing ? "closing" : ""}`}
    >

      <div className="coupon-modal">

        <h2 style={{color: '#393939'}}>
          <img src={Coupon} alt="" style={{ width: 30, marginRight: 10, marginTop: "-5px" }}/>
          Inserisci un coupon
        </h2>

        <p>
            Non hai ancora corsi assegnati, inserisci un codice valido per accedere ai corsi.
        </p>


        <input
        type="text"
        placeholder="Codice coupon"
        value={orgCode}
        onChange={(e) => setOrgCode(e.target.value)}
        style={{
            padding: "10px",
            width: "300px",
            marginBottom: "15px",
            borderRadius: "14px",
            border: "2px solid #bdbdbd",
            boxShadow: "0 6px 18px rgba(0, 0, 0, 0.10)"
        }}
        />


        <br />


        <button
        className="btn-reminder"
        onClick={handleJoinOrganization}
        disabled={joinLoading}
        >
        {
            joinLoading
            ? "Convalida..."
            : "Conferma"
        }
        </button>


        <br />


        <button
        onClick={closeOverlay}
        className="close-btn2"
        >
        ✖
        </button>


      </div>

    </div>
  );

}


export default CouponReminder;